__turbopack_context__.v({
  "resultsCount": "qxtezW_resultsCount",
  "resultsTitle": "qxtezW_resultsTitle",
  "ribbonActive": "qxtezW_ribbonActive",
  "searchDropdownContent": "qxtezW_searchDropdownContent",
  "searchDropdownWrapper": "qxtezW_searchDropdownWrapper",
  "searchMoreProductsButtonWrapper": "qxtezW_searchMoreProductsButtonWrapper",
  "searchProductCardWrapper": "qxtezW_searchProductCardWrapper",
  "searchProductsResultsList": "qxtezW_searchProductsResultsList",
});
